import YevmiyeSQLLogDBService from "../../db-services/yevmiyeSQLLogBDService";
import { ILogResponseModel } from "../types";


class YevmiyeSQLLogService {
    private dbService;

    constructor() {
        this.dbService = new YevmiyeSQLLogDBService();
    }

    async getAllLogs(dayAgo: number): Promise<ILogResponseModel[]> {
        try {
            const response = await this.dbService.getAll(dayAgo)
            return response
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

}


export default YevmiyeSQLLogService;
